module.exports = __webpack_public_path__ + "static/hero-image-1@2x-91f06e0e186ba35f65c4225b8550559c.jpg";